export default __webpack_public_path__ + "static/media/nbru_one.9d075188.png";